<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <top-nav :page_title="page_title" v-bind:search_query="search"></top-nav><br><br>
        <FlashMessage :position="'right bottom'"></FlashMessage>
        <table class="table table-hover">
          <thead class="blue-gradient white-text">
          <tr>
            <th scope="col"><em><b>ID</b></em></th>
            <th scope="col"><em><b>SAMPLE OWNER</b></em></th>
            <th scope="col"><em><b>SAMPLE CODE</b></em></th>
            <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
            <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
            <th scope="col"><em><b>PROJECT</b></em></th>
            <th scope="col"><em><b>AVAILABLE AMOUNT</b></em></th>
            <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
            <th scope="col"><em><b>APPROVED AMOUNT</b></em></th>
          </tr>
          </thead>
          <tbody>
          <tr :key="sample.id" v-for="(sample, index) in this.batchSamplesResponse">
            <td> {{ index + 1 }}</td>

            <!-- requester details -->
            <td v-if="sample['requested_sample.user.email']">
              {{ sample['requested_sample.user.first_name'] + " " + sample['requested_sample.user.last_name']}}
              <a :href="`mailto:${sample['requester.email']}`" target="_blank">
                <b-icon
                    v-b-tooltip.hover
                    :font-scale="`${font_scale}`"
                    :title="`Contact requester (${ sample['requested_sample.user.email'] })`" class="border border-info rounded"
                    icon="envelope" variant="info"
                ></b-icon>
              </a>
            </td>
            <td v-else></td>

            <td v-if="sample['requested_sample.code']"> {{ sample['requested_sample.code'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.animal_species']"> {{ sample['requested_sample.animal_species'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.sample_type']"> {{ sample['requested_sample.sample_type'] }}</td>
            <td v-else> N/A</td>
            <td v-if="sample['requested_sample.project.name']"> {{ sample['requested_sample.project.name'] }}</td>
            <td v-else> N/A</td>

            <!-- this is the available amount of the sample in the lab -->
            <td v-if="sample['requested_sample.amount']"> {{ sample['requested_sample.amount'] }}</td>
            <td v-else> N/A</td>

            <!-- this is the requested amount-->
            <td v-if="sample.amount"> {{ sample.amount }}</td>
            <td v-else> N/A</td>

            <!-- this is the approved amount-->
            <td v-if="sample.approved_amount"> {{ sample.approved_amount }}</td>
            <td v-else> N/A</td>
            &nbsp;
          </tr>
          </tbody>
        </table>

        <div class="form-group">
          <label for="description">Message:</label>
          <textarea class="form-control" id="description" name="description"
                type="text" disabled :placeholder="`${response_message}`"/>
        </div>

        <!-- DIV TO SHOW WHEN USER IS UNAUTHORIZED TO ACCESS  -->
        <div class="d-flex justify-content-center" v-if="unauthorized_text !== ''">
          <h2>{{ this.unauthorized_text }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {font_scale} from "@/utils/constants";
import {handleError, secureStoreGetAuthString, startLoader} from "@/utils/util_functions";
import axios from "axios";
import {batch_sample_response_response_resource} from "@/utils/api_paths";
import TopNav from "@/components/TopNav";

export default {
    name: "BatchSampleRequestResponseView",
    data(){
      return {
        page_title: "Batch Sample Request Response",
        responsePath: null,
        batchSamplesResponse: [],
        search: null,
        font_scale,
        unauthorized_text:'',
        response_message: 'You can go ahead and collect the approved samples from the lab. ' +
            'Kindly see the lab admin for assistance'
      }
    },

    methods: {
      getRequestResponses: function (path){
      let loader = startLoader(this)

      axios.get(path, {
        headers: {
          Authorization: secureStoreGetAuthString()
        }
      })
        .then((response) => {
          setTimeout(() => {
            loader.hide()

            if (response.status === 200){
              this.batchSamplesResponse = response.data.message
            }
          })
        })
        .catch((error) => {
            handleError(this, error, loader)
        })
      },
    },
    components: {TopNav},

    created() {
      this.responsePath = batch_sample_response_response_resource.concat(this.$router.currentRoute.params.pathMatch)
      this.getRequestResponses(this.responsePath)
    },
}
</script>